import React, { ReactChild } from 'react';

const IcChevronRight = (): ReactChild => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="current" d="M0 6l6.2-6 1.229 1.189L2.457 6l4.972 4.811L6.2 12z" transform="rotate(180 7.714 9)"/>
  </svg>
);

export default IcChevronRight;
